
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitoshirdicab() {



    const cardData =
    {
        keyword: 'Mumbai to Shirdi Cab Service',
        heading: 'S9 Travels:  Mumbai to Shirdi Cab Service',
        headingDescription: 'S9 Travels offers Mumbai to Shirdi Cab Service, ensuring a comfortable, reliable, and hassle-free travel experience. Whether you are visiting Sai Baba Temple or exploring Shirdi’s spiritual sites, our well-maintained Innova cabs provide a smooth and safe ride. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free journey. Enjoy a seamless travel experience with on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Shirdi cab with S9 Travels today!',


        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Shri Sai Baba Samadhi Mandir",
      "description": "The most revered place in Shirdi, this temple houses the samadhi (final resting place) of Sai Baba. Devotees from all over the world visit to seek blessings and experience spiritual peace."
    },
    {
      "title": "Dwarkamai",
      "description": "A sacred mosque where Sai Baba spent a significant part of his life. It holds a sacred fire (Dhuni) that has been continuously burning since Sai Baba's time, symbolizing divine blessings."
    },
    {
      "title": "Gurusthan",
      "description": "Believed to be the place where Sai Baba first appeared in Shirdi as a young boy. A neem tree here is considered sacred, and many devotees visit to pay their respects."
    },
    {
      "title": "Chavadi",
      "description": "A historic place where Sai Baba used to sleep every alternate night. It holds great religious significance and is visited by devotees as part of the Sai Baba pilgrimage."
    },
    {
      "title": "Lendi Baug",
      "description": "A beautiful garden where Sai Baba used to meditate. It has a sacred lamp (Nanda Deep) that has been burning since Baba’s time, offering a peaceful environment for visitors."
    },
    {
      "title": "Sai Heritage Village",
      "description": "A theme park that showcases the life and miracles of Sai Baba through statues and exhibits. It offers a unique experience for devotees and tourists alike."
    },
    {
      "title": "Khandoba Temple",
      "description": "A small but historically important temple dedicated to Lord Khandoba. It is believed to be the place where Sai Baba was first recognized as a saint by the local priest."
    },
    {
      "title": "Shri Sai Baba Sansthan Museum",
      "description": "A museum displaying personal belongings of Sai Baba, including his footwear, cooking vessels, and clothing, giving visitors a glimpse into his simple life."
    },
    {
      "title": "Wet N Joy Water Park",
      "description": "A popular amusement park in Shirdi, ideal for families and kids. It offers water slides, wave pools, and fun rides, making it a great place for recreation after a spiritual visit."
    },
    {
      "title": "Maruti Mandir",
      "description": "One of the oldest temples in Shirdi, dedicated to Lord Hanuman. It is believed that Sai Baba often visited this temple, and it remains a peaceful spot for devotees."
    }
],

"services": [
    {
      "name": "Mumbai to Shirdi Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services for travelers going from Mumbai to Shirdi. Whether you’re planning a one-way trip or a round trip, our professional drivers ensure a safe and enjoyable journey."
    },
    {
      "name": "Book Mumbai to Shirdi Taxi",
      "description": "Booking a taxi from Mumbai to Shirdi with S9 Travels is easy and convenient. Whether you need a one-way ride or a return journey, we provide hassle-free booking options to make your pilgrimage journey stress-free."
    },
    {
      "name": "Mumbai to Shirdi One-Way Taxi",
      "description": "Need a one-way taxi from Mumbai to Shirdi? S9 Travels offers one-way taxi services that provide comfortable and direct travel to the Shirdi temple. Our professional drivers ensure you have a smooth and timely journey."
    },
    {
      "name": "Mumbai to Shirdi Round Trip",
      "description": "Planning a round trip to Shirdi from Mumbai? S9 Travels offers round-trip taxi services that provide you with a convenient and cost-effective way to visit Shirdi and return to Mumbai in comfort and style."
    },
    {
      "name": "Affordable Mumbai to Shirdi Cab",
      "description": "Looking for an affordable cab for your trip from Mumbai to Shirdi? S9 Travels offers cost-effective taxi services that provide value for money without compromising on comfort or safety."
    },
    {
      "name": "Private Taxi for Shirdi from Mumbai",
      "description": "For a more personalized experience, choose S9 Travels' private taxi service from Mumbai to Shirdi. Travel in comfort and privacy, with a professional driver taking you directly to your destination."
    },
    {
      "name": "Luxury Cab from Mumbai to Shirdi",
      "description": "Travel in luxury with S9 Travels' premium cab service from Mumbai to Shirdi. Our luxury cabs offer the utmost comfort and a first-class travel experience, making your journey to Shirdi a memorable one."
    },
    {
      "name": "Shirdi Pilgrimage Cab Service from Mumbai",
      "description": "S9 Travels offers dedicated pilgrimage cab services from Mumbai to Shirdi, providing a comfortable and spiritual travel experience. Whether you’re visiting for a religious trip or a peaceful retreat, our services ensure a safe and smooth journey."
    },
    {
      "name": "Shirdi Temple Trip by Taxi from Mumbai",
      "description": "Take a comfortable and hassle-free trip to the Shirdi temple from Mumbai with S9 Travels' taxi service. We ensure punctuality, comfort, and a smooth ride for your spiritual journey."
    },
    {
      "name": "Mumbai to Shirdi Cab Booking",
      "description": "Booking a cab from Mumbai to Shirdi is simple and quick with S9 Travels. Choose your preferred travel dates, and we will ensure that your taxi is ready for a smooth ride to Shirdi."
    },
    {
      "name": "Shirdi Temple Tour by Taxi",
      "description": "Experience a spiritual tour of the Shirdi temple by taxi with S9 Travels. Our experienced drivers ensure you visit all the key spots and provide you with a peaceful and comfortable journey."
    },
    {
      "name": "Mumbai to Shirdi Comfort Travel",
      "description": "For a comfortable ride to Shirdi from Mumbai, choose S9 Travels' comfort travel option. Our well-maintained vehicles and skilled drivers ensure that you enjoy a smooth and comfortable ride during your trip."
    },
    {
      "name": "Group Travel to Shirdi from Mumbai",
      "description": "Planning to visit Shirdi with a group? S9 Travels offers group travel options from Mumbai to Shirdi. Whether it's a family trip or a corporate group, our spacious vehicles ensure that everyone travels comfortably together."
    }
],

"tableData": [
  ["Mumbai to Shirdi Cab Service", "Book Mumbai to Shirdi Taxi"],
  ["Mumbai to Shirdi One-Way Taxi", "Mumbai to Shirdi Round Trip"],
  ["Affordable Mumbai to Shirdi Cab", "Private Taxi for Shirdi from Mumbai"],
  ["Luxury Cab from Mumbai to Shirdi", "Shirdi Pilgrimage Cab Service from Mumbai"],
  ["Shirdi Temple Trip by Taxi from Mumbai", "Mumbai to Shirdi Cab Booking"],
  ["Shirdi Temple Tour by Taxi", "Mumbai to Shirdi Comfort Travel"],
  ["Group Travel to Shirdi from Mumbai", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Convenient Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a premium Mumbai to Shirdi cab service designed for long-distance comfort. Our vehicles, including the Toyota Innova, provide ample space, air conditioning, and a smooth ride, ensuring that you enjoy a relaxing journey to Shirdi."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service for Pilgrimage",
    "WhyChoosedescription": "Whether you're traveling for religious purposes or leisure, our cab service ensures timely pick-ups and drop-offs for your Mumbai to Shirdi trip. We prioritize punctuality, so you can focus on your trip and not worry about delays."
  },
  {
    "WhyChooseheading": "Experienced and Knowledgeable Drivers",
    "WhyChoosedescription": "Our drivers are familiar with the route between Mumbai and Shirdi, ensuring a safe and efficient journey. They prioritize your comfort and safety throughout the trip, making stops as needed and offering assistance for a smooth experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable and transparent pricing for the Mumbai to Shirdi cab service. There are no hidden charges, and we provide a clear breakdown of costs upfront, so you can plan your trip within your budget without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Secure Journey to Shirdi",
    "WhyChoosedescription": "Safety is a priority for S9 Travels. Our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts. Whether you're traveling with family or friends, you can trust that your journey from Mumbai to Shirdi will be secure and comfortable."
  },
  {
    "WhyChooseheading": "Flexible and Convenient Pick-Up Locations",
    "WhyChoosedescription": "We offer flexible pick-up locations in Mumbai for your convenience. Whether you're starting from your home, office, or a hotel, we can accommodate your preferred pick-up point and schedule, making your Mumbai to Shirdi trip seamless."
  },
  {
    "WhyChooseheading": "24/7 Availability for Your Travel Needs",
    "WhyChoosedescription": "S9 Travels is available round-the-clock, so you can book a cab for your Mumbai to Shirdi trip at any time of the day or night. Our customer support team is always ready to assist you, ensuring that your travel arrangements are handled smoothly."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Your Journey",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you're traveling for a quick pilgrimage or a leisurely trip, we offer customized travel plans for your Mumbai to Shirdi journey. Let us know your preferences, and we'll tailor the trip to ensure it meets your needs."
  }
]










    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Shirdi with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Shirdi is easy! You can book through our website or app, or simply contact our customer service team to arrange a comfortable and safe ride for your journey.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Shirdi travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Shirdi trip, including sedans, SUVs, and premium vehicles like the Toyota Innova, ensuring a comfortable and smooth journey for you and your companions.',
          },
          {
            question: 'How long does the journey from Mumbai to Shirdi take?',
            answer: 'The journey from Mumbai to Shirdi typically takes about 4.5 to 6 hours, depending on the traffic conditions and your departure time. Our drivers are experienced and will ensure you reach your destination safely and on time.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Shirdi?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the route to Shirdi. They ensure a safe, comfortable, and smooth journey for all passengers.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Shirdi?',
            answer: 'Yes, we offer round-trip bookings for Mumbai to Shirdi. You can schedule your return trip based on your preferred timing, and we will ensure a smooth and comfortable journey back.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Shirdi cab service?',
            answer: 'Our pricing for Mumbai to Shirdi cab services is flexible and based on the type of vehicle, duration, and any additional requirements you may have. Contact us for an accurate quote based on your travel details.',
          },
          {
            question: 'Do you provide pickup from Mumbai airport or hotels for Shirdi trips?',
            answer: 'Yes, we provide pickup services from both Mumbai airport and hotels for your trip to Shirdi. We ensure a seamless transfer from your desired location for a hassle-free journey.',
          },
          {
            question: 'Can I request additional stops on the way to Shirdi?',
            answer: 'Yes, if you would like to make stops on the way to Shirdi for sightseeing or breaks, simply inform us during the booking process, and we will accommodate your requests accordingly.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Shirdi trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated upfront at the time of booking, ensuring full transparency in pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Shirdi cab service?',
            answer: 'S9 Travels offers a comfortable, safe, and reliable cab service for your Mumbai to Shirdi journey. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure that your trip is pleasant and stress-free.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Singh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my family’s trip from Mumbai to Shirdi, and it was a wonderful experience. The driver was professional, the car was comfortable, and the journey was smooth. Highly recommend their services for long-distance travel!”',
        },
        {
          name: 'Mrs. Neeta Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I took a trip to Shirdi with S9 Travels from Mumbai, and the service was excellent. The driver was knowledgeable about the route and made sure we were comfortable throughout the journey. I’ll definitely choose them again for my next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Shirdi Cab Service",
        "description": "Book affordable and reliable Mumbai to Shirdi cab services for one-way trips, round trips, luxury taxis, and group travel. S9 Travels offers private taxi rides for Shirdi temple tours, pilgrimage trips, and comfortable travel options for your journey from Mumbai to Shirdi.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    

    return (
        <div>
          <Helmet>
        <title>Mumbai to Shirdi Cab | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book affordable Mumbai to Shirdi Cab services, including one-way trips, round trips, and luxury cabs. Comfortable and reliable transport for Shirdi temple tours, pilgrimage trips, and group travel from Mumbai to Shirdi with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      


<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoshirdicab;